import { render, staticRenderFns } from "./semenDespatch.vue?vue&type=template&id=f3fbc07a&scoped=true&"
import script from "./semenDespatch.vue?vue&type=script&lang=js&"
export * from "./semenDespatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fbc07a",
  null
  
)

export default component.exports